var template = function(id) {
	return cache[id] || (cache[id] = build(getTpl(id)));
};

var cache = {};

var build = function(tpl){
	return function(data){
		var compiler = compile(tpl);
		return new compiler(data).toString();
	}
}

template.build = build;

var getTpl = function(id) {
	var el = document.getElementById(id);
	return el ? el.innerHTML : '';
}

var toString = function(value) {
	var type = typeof value;
	if (type !== 'string') {
		if (type === 'number') {
			value += '';
		} else if (type === 'function') {
			value = toString(value.call(value));
		} else {
			value = '';
		}
	}
	return value;
};

var escapeMap = {
	"<": "&#60;",
	">": "&#62;",
	'"': "&#34;",
	"'": "&#39;",
	"&": "&#38;"
};

var escapeFn = function(s) {
	return escapeMap[s];
};

var escape = function(content) {
	return toString(content).replace(/&(?![\w#]+;)|[<>"']/g, escapeFn);
};

var isArray = Array.isArray || function(obj) {
	return Object.prototype.toString.call(obj) === '[object Array]';
};

var each = function(data, callback) {
	var i, len, count = 0;
	if (isArray(data)) {
		for (i = 0, len = data.length; i < len; i++) {
			callback.call(data, data[i], i, data, i);
		}
	} else {
		for (i in data) {
			callback.call(data, data[i], i, data, count);
			count++;
		}
	}
};

var compile = template.compile = function(source, data) {

	var isNewEngine = ''.trim;
	var replaces = isNewEngine ? ["$o='';", "$o+=", ";", "$o"] : ["$o=[];", "$o.push(", ");", "$o.join('')"];
	var headerCode = "'use strict';var $e=this.$e,$f=this.$f,";
	var mainCode = replaces[0];
	var footerCode = "return new String(" + replaces[3] + ");"

	each(source.split("{{"), function(code, index) {
		code = code.split("}}");
		var $0 = code[0];
		var $1 = code[1];
		var len = code.length;
		if (code.length === 1) {
			mainCode += html($0);
		} else if (len === 2) {
			mainCode += logic($0);
			if ($1) {
				mainCode += html($1);
			}
		}
	});

	function stringify(code) {
		return "'" + code
			.replace(/('|\\)/g, '\\$1')
			.replace(/\r/g, '\\r')
			.replace(/\n/g, '\\n') + "'";
	}

	function html(code) {
		if (code) {
			code = replaces[1] + stringify(code) + replaces[2];
		}
		return code;
	}

	function logic(code) {
		code = code.replace(/^\s+|\s+$/, '');
		var split = code.split(/\s+/);
		var key = split.shift();
		var args = split.join(' ');
		switch (key) {
			case 'if':
				code = 'if(' + args + '){';
				break;

			case 'else':
				code = '}else{';
				break;

			case 'elseif':
				code = '}else if(' + args + '){';
				break;

			case '/if':
				code = '};';
				break;

			case 'for':
				split[0] = split[0] || '$d';
				split[1] = split[1] || '$v';
				split[2] = split[2] || '$k';
				code = '$f(' + split.shift() + ',function(' + split.join() + '){';
				break;

			case '/for':
				code = '});';
				break;

			case 'eval':
				code = args + ';';
				break;

			case '#':
				code = replaces[1] + "$e(" + code + ")" + replaces[2];
				break;

			default:
				code = replaces[1] + code + replaces[2];
				break;
		}
		return code;
	}
	var compiler = new Function("$d", headerCode + mainCode + footerCode);
	compiler.prototype.$e = escape;
	compiler.prototype.$f = each;
	return compiler;
}

module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/common/template.js
// module id = 19
// module chunks = 2